import { ref, Ref } from 'vue';
import { injectable } from 'inversify';
import { ReadmissionHistory, ReadmissionManagerRunner } from './ReadmissionManagerRunner';

@injectable()
export class ReadmissionService {
    public static readonly VARIABLE_FOR_READMISSION_DATE = 'core.administrativeInfo.icuAdmDate' as const;
    
    public currentRunner: ReadmissionManagerRunner | undefined = undefined;
    readonly showUserDialog = ref(false);
    readonly dialogResult = ref(false);
    readonly firstCase: Ref<any> = ref();
    readonly patientHistory: Ref<ReadmissionHistory[]> = ref([]);

    registerRunner(newRunner: ReadmissionManagerRunner) {
        try {
            if (this.currentRunner) {
                throw new Error("There's already a current runner. Maybe we forgot to call unregisterRunner()?");
            }
            this.currentRunner = newRunner;
        } catch (e) {
            if (e instanceof Error) {
                console.error(e.message);
            } else {
                console.error("An unknown error occurred in registerRunner.");
            }
            // Attempt to unregister the existing runner if there is one
            if (this.currentRunner) {
                this.unregisterRunner(this.currentRunner);
            }
        }
    }

    unregisterRunner(callingRunner: ReadmissionManagerRunner) {
        try {
            if (!this.currentRunner) {
                throw new Error("There's no runner registered");
            }
            if (callingRunner.id !== this.currentRunner.id) {
                throw new Error("There's another registered runner");
            }

            this.currentRunner = undefined;
        } catch (e) {
            if (e instanceof Error) {
                console.error(e.message);
            } else {
                console.error("An unknown error occurred in unregisterRunner.");
            }
        }
    }
}
